import { calculateAssetVaue } from '@unistocks/features/portfolios/portfolio-utils';
import { PortfolioDto } from '@unistocks/proxy/axios-client';
import { PortfolioFilter } from '@unistocks/shared/filter';
import { useMemo } from 'react';

export const usePortfolioValue = (portfolio?: PortfolioDto, filter?: PortfolioFilter) =>
  useMemo(() => (portfolio ? calculateAssetVaue(portfolio, filter ?? {}) : 0), [portfolio, filter]);
